import React, { Fragment } from 'react';
import Carousel from 'react-multi-carousel';
import CameraOutlined from '@ant-design/icons/CameraOutlined';
import {
  Wrapper,
  PlaceholderWrapper,
  NumberWrapper,
  Number
} from './CardCarousel.style';

import 'react-multi-carousel/lib/styles.css';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    paritialVisibilityGutter: 40
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    paritialVisibilityGutter: 30
  }
};

export const CardCarouselPlaceholder = ({ height = 170 }) => {
  return (
    <PlaceholderWrapper
      height={height}
      className='carousel_placeholder_wrapper'
    />
  );
};

const CardCarousel = ({
  children,
  height = 170,
  mobileMode = false,
  beforeChange,
  afterChange
}) => {
  const attrs = {
    additionalTransfrom: 0,
    arrows: true,
    autoPlaySpeed: 3000,
    containerClass: 'container',
    dotListClass: '',
    draggable: true,
    focusOnSelect: false,
    infinite: true,
    itemClass: '',
    renderDotsOutside: false,
    responsive,
    showDots: !mobileMode,
    sliderClass: '',
    slidesToSlide: 1,
    beforeChange,
    afterChange
  };
  return (
    <Wrapper className={mobileMode ? 'mobile' : ''} height={height}>
      <Carousel {...attrs}>{children}</Carousel>
      {mobileMode && !!children.length && (
        <NumberWrapper>
          <CameraOutlined style={{ fontSize: 18, color: '#ffffff' }} />
          <Number>{children.length}</Number>
        </NumberWrapper>
      )}
    </Wrapper>
  );
};

export default CardCarousel;
